import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import { decryptData } from 'utils/crypto';

import {
  Layout,
  Input,
  Space,
  Button,
  Typography,
  Dropdown,
  Checkbox,
  message,
  Menu,
  Modal,
  Select,
  Form,
  Table,
  DatePicker,
} from 'antd';
import { AiOutlineSearch } from 'react-icons/ai';
import { FaChevronDown } from 'react-icons/fa';
import {
  UserAddOutlined,
  DeleteOutlined,
  SettingOutlined,
  PlusSquareOutlined,
  UserSwitchOutlined,
  LinkOutlined,
} from '@ant-design/icons';
import { FiMoreHorizontal } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Flex, IconButton } from '@chakra-ui/react';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { UserDeleteOutlined } from '@ant-design/icons';
import { setTaskstatuslist } from 'store/actions';
import { settaskBoardDetails } from 'store/actions';
import Cookies from 'js-cookie';
import { PlusOutlined } from '@ant-design/icons';
import { setEpiclist } from 'store/actions';
import dayjs from 'dayjs';
import { settaskstatuscount } from 'store/actions';
import { setassigneelist } from 'store/actions';
import { useFetchBacklogData } from 'views/admin/taskManagement/BackLogPage/Alldata';
import { setSprintlist } from 'store/actions';
import { setTimelineEpicList } from 'store/actions';
import { setEpicTaskList } from 'store/actions';
import InviteProject from './InviteProject';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import ReactQuill from 'react-quill';
import UserAvatar from '../../../../components/userAvatar/index';
import {
  RightOutlined,
  DownOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import LinkWorkItems from './LinkWorkItems';

// const roleId = Cookies.get('task-role-id');
const { Option } = Select;

const { Title } = Typography;
const { Header } = Layout;

// const epicOptions = ['No Epic', 'SAM', 'VTS', 'Orion', 'Peace Payroll'];
// const labelOptions = ['api', 'backend', 'frontend', 'data', 'devops'];
// const typeOptions = ['⛔ Bug', '🔰 Story', '✔️ Task'];

const AVATARS_PER_PAGE = 5;

const SubHeaderBar = ({ activeTab, openLinkConfig }) => {
  const [form] = Form.useForm();
  const [addTaskForm] = Form.useForm();
  const [isLoading, setisLoading] = useState(false);

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [users, setUsers] = useState([]);
  const [selectedEpics, setSelectedEpics] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeactivateModalVisible, setIsDeactivateModalVisible] =
    useState(false);
  const [newStatusName, setNewStatusName] = useState('');
  const [departments, setDepartments] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedAdmins, setSelectedAdmins] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedViewers, setSelectedViewers] = useState([]);
  const [isAddMemberModalVisible, setIsAddMemberModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isProjectModalVisible, setIsProjectModalVisible] = useState(false);
  const [unselectedEmployees, setUnselectedEmployees] = useState([]);
  const [existingDepartments, setExistingDepartments] = useState([]);
  const [updatedDepartments, setUpdatedDepartments] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [isRemoveModalVisible, setIsRemoveModalVisible] = useState(false);
  const [roleId, setRoleId] = useState('');
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [labelOptions, setLabelOptions] = useState([]);
  const [epicOptions, setEpicOptions] = useState([]);
  
  const [isTaskModalVisible, setIsTaskModalVisible] = useState(false);
  const [isEpicModalVisible, setIsEpicModalVisible] = useState(false);
  const [epicName, setEpicName] = useState('');
  const [projectEmployees, setProjectEmployees] = useState([]);
  const [showTaskFields, setShowTaskFields] = useState(false);
  const [projectDetails, setprojectDetails] = useState({});
  const [assignedEmployee, setAssignedEmployee] = useState([]);
  const [showLinkWorkItems, setShowLinkWorkItems] = useState(false);
   const [issueTypes, setIssueTypes] = useState([]);
   const [selectedIssue, setSelectedIssue] = useState(null);
  const dispatch = useDispatch();
  const status = useSelector(
    (status) => status?.Authentication?.taskstatuslist,
  );

  const [isInviteMemberVisible, setIsInviteMemberVisible] = useState(false);
  const workType = Form.useWatch('work_type', addTaskForm);
  const sprintList = useSelector(
    (state) => state?.Authentication?.sprintlist || [],
  );
 

  const ROLE_MAP = {
    Admin: { id: 1, label: 'Admin' },
    Member: { id: 2, label: 'Member' },
    Viewer: { id: 3, label: 'Viewer' },
  };

  // const projectName = useSelector((state) => state.Authentication?.projectName);
  const projectName = Cookies.get('project_name');
  const project_id = useParams();

  const { fetchBacklogData, setBacklogData } = useFetchBacklogData(project_id);

  const maxPage = Math.ceil(users.length / AVATARS_PER_PAGE) - 1;
  const visibleAvatars = users.slice(
    currentPage * AVATARS_PER_PAGE,
    (currentPage + 1) * AVATARS_PER_PAGE,
  );

   const adminroleId = decryptData(Cookies.get('role_id'));

  const columns = [
    {
      title: (
        <Checkbox
          checked={
            selectedUserIds.length === projectEmployees.length &&
            projectEmployees.length > 0
          }
          indeterminate={
            selectedUserIds.length > 0 &&
            selectedUserIds.length < projectEmployees.length
          }
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedUserIds(projectEmployees.map((user) => user.user_id));
            } else {
              setSelectedUserIds([]);
            }
          }}
        />
      ),
      dataIndex: 'select',
      render: (_, record) => (
        <Checkbox
          checked={selectedUserIds.includes(record.user_id)}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedUserIds((prev) =>
              checked
                ? [...prev, record.user_id]
                : prev.filter((id) => id !== record.user_id),
            );
          }}
        />
      ),
      width: 50,
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Role',
      dataIndex: 'project_role',
      key: 'project_role',
    },
  ];

  const handleDeleteUsers = async () => {
    const reqBody = {
      project_id: Number(project_id.id),
      remove_team_members: selectedUserIds,
    };

    try {
      const response =
        await httpInjectorService.taskManagementRemoveTeamMembers(reqBody);
    
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setIsRemoveModalVisible(false);
        setSelectedUserIds([]);
        getProjectEmployees();
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }

      // Optionally refresh projectEmployees here
    } catch (err) {
      console.error('Failed to delete users:', err);
      setSelectedUserIds([]);
    }
  };

  const fetchData = async () => {
    try {
      const [sprintRes, epicRes, taskRes] = await Promise.all([
        httpInjectorService.timeline_Sprintlist(`?project_id=${project_id.id}`),
        httpInjectorService.timeline_Epiclist(`?project_id=${project_id.id}`),
        httpInjectorService.gettimelinetask(`?project_id=${project_id.id}`),
      ]);

      // Dispatch data to Redux
      dispatch(
        setSprintlist(sprintRes?.status === 'success' ? sprintRes.data : []),
      );
      dispatch(
        setTimelineEpicList(epicRes?.status === 'success' ? epicRes.data : []),
      );
      dispatch(
        setEpicTaskList(taskRes?.status === 'success' ? taskRes.data : []),
      );
    } catch (err) {
      console.error('Timeline fetch error', err);
      dispatch(setSprintlist([]));
      dispatch(setTimelineEpicList([]));
      dispatch(setEpicTaskList([]));
    }
  };

  const handlePageChange = (direction) => {
    setCurrentPage((prev) => {
      if (direction === 'left' && prev > 0) return prev - 1;
      if (direction === 'right' && prev < maxPage) return prev + 1;
      return prev;
    });
  };

  const handleUserClick = (userId) => {
   
    message.info(`Fetching data for user ID: ${userId}`);
  };

  const handleMenuClick = async ({ key }) => {
    switch (key) {
      case 'addMembers':
        getProjectDetails();
        setIsAddMemberModalVisible(true);
        break;
      case 'inviteMembers':
        setIsInviteMemberVisible(true);
        break;
      case 'projectMembers':
        setIsRemoveModalVisible(true);
        getProjectEmployees();
        break;
      case 'deleteProject':
        setIsDeleteModalVisible(true);
        break;
      case 'createLinkItems':
        setShowLinkWorkItems(true);
        break;
      case 'deactivateProject':
        setIsDeactivateModalVisible(true);
        break;
      case 'addStatus':
        setIsModalVisible(true);
        break;
      case 'projectSettings':
        getProjectDetails();
        setIsProjectModalVisible(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    getSelectedProjectRoles();
    getIssueTypes();
  }, []);

  const handleDeactivateProject = async () => {
    try {
      const projectNumber = Number(project_id.id); // Convert '34' to 34
     

      const response =
        await httpInjectorService.taskManagementDeactivateProject(
          projectNumber,
        );

      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setIsDeactivateModalVisible(false);
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(err, {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const handleDeleteProject = async () => {
    const projectNumber = Number(project_id.id);
    try {
      const response =
        await httpInjectorService.taskManagementDeleteProject(projectNumber);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setIsDeleteModalVisible(false);
        navigate('/admin/TaskManagement');
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(err, {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const handleEditProject = async () => {
    try {
      const values = await form.validateFields();
      const reqBody = {
        project_id: Number(project_id.id),
        project_name: values.projectName.trim(),
        project_key: values.projectKey,
        git_repo_url: values.repository,
        production_url: values.productionUrl,
        development_url: values.developmentUrl,
      };
   
      const response =
        await httpInjectorService.taskManagementEditProject(reqBody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setIsProjectModalVisible(false);
        form.resetFields();
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(err, {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const getDepartments = async () => {
    try {
      const response =
        await httpInjectorService.getDepartmentsForTaskManagement();
      if (response.status === 'success') {
        setDepartments(response.data);
      } else {
        console.error('Failed to fetch departments:', response.message);
      }
    } catch (err) {
      console.error('Error while fetching departments:', err);
      toast.error('Failed to fetch departments');
    }
  };

  const getEpiclist = async () => {
    const queryParams = `?project_id=${project_id.id}`;
    try {
      const response = await httpInjectorService.get_epic(queryParams);
     
      dispatch(setEpiclist(response.data));
    } catch (error) {
      console.error('Failed to fetch epics:', error);
    } finally {
    }
  };

  const getUnselectedEmployees = async () => {
    const projectId = Number(project_id.id);
    if (!projectId) {
      setUnselectedEmployees([]);
      return;
    }

    try {
      const response =
        await httpInjectorService.taskManagementGetUnselectedEmployees({
          project_id: projectId,
        });

      if (response.status === 'success') {
        setUnselectedEmployees(response.data); // Adjust based on actual response shape
      }
    } catch (err) {
      console.error('Error fetching unselected employees:', err);
    }
  };

  const handleAddStatus = async () => {
    const reqBody = {
      project_id: project_id.id,
      status_name: newStatusName,
    };

    try {
      const response = await httpInjectorService.addBoardstatus(reqBody);

      if (response.status === 'success') {
        listBoardStatus();
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setIsModalVisible(false);
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Failed to add new status:', error);
      toast.error('Error adding status');
    }
  };

  const listBoardStatus = async () => {
    try {
      const response = await httpInjectorService.ListBoardStatus(project_id.id);
      if (response.status === 'success' && Array.isArray(response.data)) {
        const statusList = response?.data;
        dispatch(setTaskstatuslist(statusList));
        // setStatus(statusList);
        // setColumnOrder(statusList?.map((s) => s.status_name)); // 👈 track order separately

        // Initialize empty task arrays dynamically
        const initialTasks = {};
        statusList.forEach((s) => {
          initialTasks[s.status_name] = [];
        });
   
        dispatch(settaskBoardDetails(initialTasks));
      } else {
        // setStatus([]);
        dispatch(setTaskstatuslist([]));
        // set({});
      }
    } catch (error) {
      console.error('Failed to fetch board statuses', error);
    }
  };

  const fetchDropdowns = async () => {
    const projectNumber = Number(project_id.id);
    try {
      const [employeeRes, labelsRes, epicsRes] = await Promise.all([
        httpInjectorService.getProjectAssignedEmployeelist(projectNumber),
        httpInjectorService.boardFilterLabels(projectNumber),
        httpInjectorService.boardFilterEpics(projectNumber),
      ]);

      const formattedEmployees = (employeeRes?.data || []).map((emp) => ({
        id: emp.user_id,
        name: `${emp.username} (${emp.project_role})`,
      }));

      const formattedLabels = (labelsRes?.data || []).map((label) => ({
        id: label.label_id,
        name: label.label_name,
      }));

      const formattedEpics = (epicsRes?.data || []).map((epic) => ({
        id: epic.epic_id,
        name: epic.epic_name,
      }));

      setEmployeeOptions(formattedEmployees);
      setLabelOptions(formattedLabels);
      setEpicOptions(formattedEpics);
    } catch (err) {
      console.error('Dropdown fetch failed:', err);
      setEmployeeOptions([]);
      setLabelOptions([]);
      setEpicOptions([]);
    }
  };

  const handlecloseLinkworkItems = () => {
    setShowLinkWorkItems(false);
  };

  useEffect(() => {
    fetchDropdowns();
  }, [isTaskModalVisible]);

  const projectMenu = (
    <Menu onClick={handleMenuClick}>
      {roleId === 1 && (
        <Menu.Item key="addMembers" icon={<UserAddOutlined />}>
          Add Members
        </Menu.Item>
      )}
      {roleId === 1 && (
        <Menu.Item key="inviteMembers" icon={<UserSwitchOutlined />}>
          Invite Members
        </Menu.Item>
      )}
      {roleId === 1 && (
        <Menu.Item key="projectMembers" icon={<UserDeleteOutlined />}>
          Project Members
        </Menu.Item>
      )}

      {(roleId === 1 || roleId === 2) && (
        <Menu.Item key="deactivateProject" icon={<SettingOutlined />}>
          Deactivate Project
        </Menu.Item>
      )}

      {(roleId === 1 || roleId === 2) && (
        <Menu.Item key="addStatus" icon={<PlusSquareOutlined />}>
          Add Status
        </Menu.Item>
      )}

      {(roleId === 1 || roleId === 2) && (
        <Menu.Item key="projectSettings" icon={<SettingOutlined />}>
          Project Settings
        </Menu.Item>
      )}
      {(roleId === 1) && (
        <Menu.Item key="createLinkItems" icon={<LinkOutlined />}>
          Create Link Items
        </Menu.Item>
      )}

      {(roleId === 1 || roleId === 2) && (
        <Menu.Item key="deleteProject" icon={<DeleteOutlined />} danger>
          Delete Project
        </Menu.Item>
      )}
    </Menu>
  );

  const createCheckboxDropdown = (title, options, selected, onChange) => (
    <Dropdown
      trigger={['click']}
      dropdownRender={() => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            options={options}
            value={selected}
            onChange={onChange}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              backgroundColor: 'white',
            }}
          />
        </div>
      )}
    >
      <div style={{ cursor: 'pointer' }}>
        <Space>
          {title}
          <FaChevronDown />
        </Space>
      </div>
    </Dropdown>
  );

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const fetchedUsers = [
          { id: 'u1', initials: 'AL', color: '#1890ff' },
          { id: 'u2', initials: 'SH', color: '#2f54eb' },
          { id: 'u3', initials: 'NS', color: '#722ed1' },
          { id: 'u4', initials: 'PW', color: '#f5222d' },
          { id: 'u5', initials: 'SC', color: '#389e0d' },
          { id: 'u6', initials: 'AN', color: '#13c2c2' },
          { id: 'u7', initials: 'RM', color: '#fa8c16' },
          { id: 'u8', initials: 'VK', color: '#eb2f96' },
        ];
        setUsers(fetchedUsers);
      } catch (err) {
        message.error('Failed to fetch users');
      }
    };

    fetchUsers();
  }, []);

  const getSelectedProjectRoles = async () => {
    // const project_id: Number(project_id.id)
    const id = Number(project_id.id);
    try {
      const response = await httpInjectorService.getSingleProjectPermission(id);
      Cookies.set('task-role-id', String(response.data.role_id));
      setRoleId(response.data.role_id);
    } catch (err) {}
  };

  useEffect(() => {
    getDepartments();
  }, [isAddMemberModalVisible]);

  // const renderEmployeeOptions = () =>
  //   employees.length > 0
  //     ? employees.map(emp => (
  //         <Option key={emp.id} value={emp.id}>
  //           {emp.name}
  //         </Option>
  //       ))
  //     : [<Option key="no-data" disabled>No data</Option>];

  const getFilteredOptions = (excludeIds = []) => {
    return unselectedEmployees
      .filter((user) => !excludeIds.includes(user.user_id))
      .map((user) => (
        <Option key={user.user_id} value={user.user_id}>
          {user.username}
        </Option>
      ));
  };

  const getProjectDetails = async () => {
    const id = Number(project_id.id);
    try {
      const response =
        await httpInjectorService.taskManagementGetProjectDetails(id);
      if (response.status === 'success' && Array.isArray(response.data)) {
        const project = response.data[0]; // First project object
        setprojectDetails(project);
        // console.log(project, "project details")
        const departments = project.departments || [];
       
        setExistingDepartments(departments);
      } else {
      }
    } catch (err) {}
  };

  const handleSubmitNewDepartments = async () => {
    const reqBody = {
      project_id: Number(project_id.id),
      department_id: updatedDepartments,
    };
  
    try {
      const response =
        await httpInjectorService.updateProjectDepartments(reqBody);
      if (response.status === 'success') {
        // toast.success(response.message, {
        //   position: 'top-right',
        //   autoClose: 3000,
        // });
        setExistingDepartments([]);
        setUpdatedDepartments([]);
      }
    } catch (err) {}
  };

  const getProjectEmployees = async () => {
    const id = Number(project_id.id);
    try {
      const response = await httpInjectorService.boardFilterAssignments(id);
      if (response.status === 'success') {
        setProjectEmployees(response.data);
        dispatch(setassigneelist(response.data));
      } else {
        setProjectEmployees([]);
        dispatch(setassigneelist([]));
      }
    } catch (err) {}
  };

  const getprojectAssignedEmployee = async () => {
    try {
      let response = await httpInjectorService.getProjectAssignedEmployeelist(
        project_id.id,
      );
      if (response.status === 'success') {
        setAssignedEmployee(response.data);
        dispatch(setassigneelist(response.data));
      } else {
        setAssignedEmployee('');
        dispatch(setassigneelist([]));
      }
    } catch (error) {
      console.error('Failed to fetch employee', error);
    }
  };

  const handleSubmitNewMembers = async (reqBody) => {
    try {
      const response =
        await httpInjectorService.updateProjectTeamMembers(reqBody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        getprojectAssignedEmployee();
        setIsAddMemberModalVisible(false);
        setSelectedAdmins([]);
        setSelectedMembers([]);
        setSelectedViewers([]);
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {}
  };

  const handleSubmit = async () => {
  
    const buildPayload = (userIds, roleKey) =>
      userIds.map((id) => {
        const user = unselectedEmployees.find((u) => u.user_id === id);
        return {
          user_id: user.user_id,
          username: user.username,
          project_role_id: ROLE_MAP[roleKey].id,
          project_role: ROLE_MAP[roleKey].label,
        };
      });

    const team_members = [
      ...buildPayload(selectedAdmins, 'Admin'),
      ...buildPayload(selectedMembers, 'Member'),
      ...buildPayload(selectedViewers, 'Viewer'),
    ];

    const reqBody = {
      project_id: Number(project_id.id),
      team_members,
    };

    // Call your API here
   

    await handleSubmitNewDepartments();
    await handleSubmitNewMembers(reqBody);
  };

  useEffect(() => {
    if (status?.length) {
      const todo = status.find((s) => s.status_name === 'TO DO');
      if (todo) {
        addTaskForm.setFieldsValue({ status: todo.id });
      }
    }
  }, [status, addTaskForm]);

 const handleEpicSubmit = async () => {
  try {
    const values = await addTaskForm.validateFields();
  

    const formatDate = (date) =>
      date ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : null;

    const reqBody = {
      ...values,
      project_id: Number(project_id.id),
      issue_status: "TO DO",
      issue_type_id: selectedIssue,
      start_date: formatDate(values.start_date),
      due_date: formatDate(values.due_date),
    };

    // If Epic selected → include epic_name
    if (selectedIssue === "epic") {
      reqBody.epic_name = values?.issue_title
    }

   

    const response =
      selectedIssue === "epic"
        ? await httpInjectorService.taskManagementAddEpic(reqBody)
        : await httpInjectorService.addWorkItem(reqBody);

    if (response.status === "success") {
      toast.success(response.message, {
        position: "top-right",
        autoClose: 3000,
      });

      setIsTaskModalVisible(false);
      addTaskForm.resetFields();
      setShowTaskFields(false);

      if (selectedIssue === "epic") {
        getEpiclist();
        fetchDropdowns();
        fetchData();
      } else {
        await fetchBacklogData();
      }
    } else {
      toast.error(response.message, {
        position: "top-right",
        autoClose: 3000,
      });
    }
  } catch (err) {
    console.error("Form submission failed:", err);
  }
};
  const role_Id = Cookies.get('task-role-id');


  const handleCreatebutton = async () => {
    setIsTaskModalVisible(true);
  };

  const handleAddEpic = async () => {
   
    setEpicName('');
    setIsEpicModalVisible(false);
    const reqBody = {
      epic_name: epicName,
      project_id: Number(project_id.id),
    };

    try {
      const response = await httpInjectorService.taskManagementAddEpic(reqBody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        getEpiclist();
        fetchDropdowns();
        fetchData();
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (isProjectModalVisible && projectDetails) {
      form.setFieldsValue({
        projectName: projectDetails.project_name,
        projectKey: projectDetails.project_key,
        repository: projectDetails.git_repo_url,
        productionUrl: projectDetails.production_url,
        developmentUrl: projectDetails.development_url,
      });
    }
  }, [isProjectModalVisible, projectDetails, form]);

  const onClickUnSelectedEmployees = () => {
    getUnselectedEmployees();
  };

  const getIcon = (type, size = 18) => {
  switch (type?.toUpperCase()) {
    case 'TASK':
      return <TaskObject width={size} stroke="#0052CC" />;
    case 'STORY':
      return <StoryObject width={size} stroke="#36B37E" />;
    case 'BUG':
      return <BugObject width={size} stroke="#172B4D" />;
    case 'EPIC':
      return <ThunderboltOutlined style={{ color: '#884B9E', fontSize: size }} />;
    default:
      return null;
  }
};

    const getIssueTypes = async () => {
        try {
          const response = await httpInjectorService.getIssueTypes();
    
          if (response.status === 'success') {
            setIssueTypes(response.data);
          }
        } catch (error) {
          throw error;
        }
      };


const options = [
  ...issueTypes,
  { issue_type: 'EPIC', issue_type_id: 'epic' }
];

const menuItems = [
  {
    key: "1",
    label: "Link Item Configuration",
  },
];

const handleSettingsMenuClick = ({ key }) => {
  if (key === "1") {
    openLinkConfig();
  }
};

const startTourAgain = () => {

  window.dispatchEvent(new Event("restart-project-tour"));
};

    

  return (
    <React.Fragment>
      <Header
        style={{
          position: 'fixed',
          top: 50,
          left: 50,
          right: 0,
          width: 'calc(100%-120px)',
          zIndex: 0,
          background: '#fff',
          padding: '12px 24px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          minHeight: '60px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            flexWrap: 'wrap', // ensures responsiveness
            gap: '12px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              flexShrink: 1,
            }}
          >
            <h2 style={{ margin: 0, fontSize: '25px' }}>{projectName}</h2>

            <Dropdown overlay={projectMenu} trigger={['click']}>
              <Button
                onClick={onClickUnSelectedEmployees}
                icon={<FiMoreHorizontal />}
              />
            </Dropdown>

            {/* <Input
              prefix={<AiOutlineSearch />}
              placeholder="Search"
              style={{ width: '200px' }}
            /> */}
          </div>

        <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    flexGrow: 1,
    alignItems: "center",
    gap: "10px",
  }}
>
  <Button
  type="primary"
  size="small"
  style={{
    marginRight: 20,
    borderRadius: 20,
  }}
  onClick={startTourAgain}
>
  Start Tour
</Button>
  <Button
    type="primary"
    style={{ backgroundColor: "#722ED1", borderColor: "#722ED1" }}
    onClick={handleCreatebutton}
  >
    Create
  </Button>

  <Dropdown
    menu={{
      items: menuItems,
      onClick: handleSettingsMenuClick,
    }}
    trigger={["click"]}
  >
    <SettingOutlined style={{ fontSize: 18, cursor: "pointer" }} />
  </Dropdown>

</div>
        </div>

        <Modal
          title="Add New Status"
          visible={isModalVisible}
          onOk={handleAddStatus}
          onCancel={() => {
            setIsModalVisible(false);
            setNewStatusName('');
          }}
          okButtonProps={{
            style: {
              backgroundColor: '#722ED1',
              borderColor: '#722ED1',
              color: '#fff',
            },
          }}
        >
          <Input
            value={newStatusName}
            onChange={(e) => setNewStatusName(e.target.value)}
            placeholder="Enter status name"
            autoFocus
          />
        </Modal>

        <Modal
          title="Add New Members"
          visible={isAddMemberModalVisible}
          onOk={handleSubmit}
          onCancel={() => {
            setIsAddMemberModalVisible(false);
            setSelectedAdmins([]);
            setSelectedMembers([]);
            setSelectedViewers([]); // ← You missed this one in your snippet
            setExistingDepartments([]);
            setUpdatedDepartments([]);
            setUnselectedEmployees([]);
          }}
          okButtonProps={{
            style: {
              backgroundColor: '#722ED1',
              borderColor: '#722ED1',
              color: '#fff',
            },
          }}
        >
          <div style={{ marginBottom: 16 }}>
            <label>Select Admins</label>
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Select admins"
              value={selectedAdmins}
              onChange={setSelectedAdmins}
            >
              {getFilteredOptions([...selectedMembers, ...selectedViewers])}
            </Select>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>Select Members</label>
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Select members"
              value={selectedMembers}
              onChange={setSelectedMembers}
            >
              {getFilteredOptions([...selectedAdmins, ...selectedViewers])}
            </Select>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>Select Viewers</label>
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Select viewers"
              value={selectedViewers}
              onChange={setSelectedViewers}
            >
              {getFilteredOptions([...selectedAdmins, ...selectedMembers])}
            </Select>
          </div>
        </Modal>

        <InviteProject
          open={isInviteMemberVisible}
          projectId={Number(project_id.id)}
          onClose={() => setIsInviteMemberVisible(false)}
        />

        <Modal
          title="Confirm Deactivation"
          visible={isDeactivateModalVisible}
          onOk={handleDeactivateProject}
          onCancel={() => setIsDeactivateModalVisible(false)}
          okText="Deactivate"
          cancelText="Cancel"
          okButtonProps={{
            style: {
              backgroundColor: '#722ED1',
              borderColor: '#722ED1',
              color: '#fff',
            },
          }}
        >
          <p>
            Are you sure you want to deactivate this project? This action cannot
            be undone.
          </p>
        </Modal>

        <Modal
          title="Confirm Deletion"
          visible={isDeleteModalVisible}
          onOk={handleDeleteProject}
          onCancel={() => setIsDeleteModalVisible(false)}
          okText="Delete"
          cancelText="Cancel"
          okButtonProps={{
            style: {
              backgroundColor: '#FF0033',
              borderColor: '#d8002bff',
              color: '#fff',
            },
          }}
        >
          <p>
            Are you sure you want to <strong>permanently delete</strong> this
            project? This action cannot be undone and all associated data will
            be lost.
          </p>
        </Modal>

        <Modal
          title="Update Project Details"
          visible={isProjectModalVisible}
          onOk={handleEditProject}
          onCancel={() => {
            form.resetFields();
            setIsProjectModalVisible(false);
          }}
          okText="Save"
          cancelText="Cancel"
          okButtonProps={{
            style: {
              backgroundColor: '#722ED1',
              borderColor: '#722ED1',
              color: '#fff',
            },
          }}
        >
          <Form form={form} layout="vertical">
            <Form.Item
              label="Project Name"
              name="projectName"
              rules={[
                { required: true, message: 'Please enter the project name' },
              ]}
            >
              <Input placeholder="e.g. Task Management System" disabled />
            </Form.Item>

            <Form.Item
              label="Project Key"
              name="projectKey"
              rules={[
                { required: true, message: 'Please enter the project key' },
                {
                  pattern: /^[A-Z0-9]+$/,
                  message:
                    'Only uppercase letters and numbers are allowed. No spaces, hyphens, or special characters.',
                },
              ]}
            >
              <Input placeholder="e.g. TMS001" disabled />
            </Form.Item>

            <Form.Item label="Production URL" name="productionUrl">
              <Input placeholder="https://prod.example.com" />
            </Form.Item>

            <Form.Item label="Development URL" name="developmentUrl">
              <Input placeholder="https://dev.example.com" />
            </Form.Item>
            <Form.Item label="Github Repository" name="repository">
              <Input placeholder="e.g. https://github.com/owner/repository-name" />
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title=" Project Members"
          visible={isRemoveModalVisible}
          onCancel={() => {
            setIsRemoveModalVisible(false);
            setSelectedUserIds([]);
          }}
          footer={null}
          width={700}
        >
          <Space
            style={{
              justifyContent: 'flex-end',
              width: '100%',
              marginBottom: 16,
            }}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              disabled={selectedUserIds.length === 0}
              onClick={handleDeleteUsers}
            >
              Delete Selected Users
            </Button>
          </Space>

          <Table
            dataSource={projectEmployees}
            columns={columns}
            rowKey="user_id"
            pagination={false}
          />
        </Modal>

        <Modal
          title="Create Task"
          open={isTaskModalVisible}
          width={800}
          destroyOnClose
          onCancel={() => {
            setIsTaskModalVisible(false);
            addTaskForm.resetFields();
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setIsTaskModalVisible(false);
                addTaskForm.resetFields();
              }}
            >
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleEpicSubmit}>
              Create
            </Button>,
          ]}
        >
          <Form
            form={addTaskForm}
            layout="vertical"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            {/* Work Type */}
            <Form.Item
              name="work_type"
              label="Work type"
              rules={[{ required: true, message: 'Please select work type' }]}
            >
              <Select
  placeholder="Select work type"
  optionLabelProp="label"
  onChange={(value) =>setSelectedIssue(value)}
>
  {[...issueTypes, { issue_type: 'EPIC', issue_type_id: 'epic' }].map((type) => (
    <Select.Option
      key={type.issue_type_id}
      value={type.issue_type_id}
      label={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          {getIcon(type.issue_type, 18)}
          <span>
            {type.issue_type.charAt(0) +
              type.issue_type.slice(1).toLowerCase()}
          </span>
        </div>
      }
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        {getIcon(type.issue_type, 18)}
        <span>
          {type.issue_type.charAt(0) +
            type.issue_type.slice(1).toLowerCase()}
        </span>
      </div>
    </Select.Option>
  ))}
</Select>
         </Form.Item>

            {/* Status */}
            <Form.Item name="status" label="Status">
              <Select placeholder="Select status">
                {status
                  ?.sort((a, b) => a.order_by - b.order_by)
                  ?.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.status_name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            {/* Summary */}
            <Form.Item
              name="issue_title"
              label="Summary"
              rules={[{ required: true, message: 'Summary is required' }]}
            >
              <Input placeholder="What needs to be done?" />
            </Form.Item>

            {/* Description */}
            <Form.Item name="description" label="Description">
              <Form.Item noStyle shouldUpdate>
                {({ getFieldValue, setFieldsValue }) => (
                  <ReactQuill
                    theme="snow"
                    value={getFieldValue('description')}
                    onChange={(value) => setFieldsValue({ description: value })}
                    placeholder="Add a description..."
                    style={{ minHeight: 140 }}
                    modules={{
                      toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ color: [] }, { background: [] }],
                        ['link', 'image', 'code-block'],
                        ['clean'],
                      ],
                    }}
                  />
                )}
              </Form.Item>
            </Form.Item>

            {/* Assignee */}
            <Form.Item name="assignee_id" label="Assignee">
              <Select placeholder="Assign to" allowClear>
                {employeeOptions.map((emp) => (
                  <Select.Option key={emp.id} value={emp.id}>
                    {emp.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {/* Labels */}
            <Form.Item name="labels" label="Labels">
              <Select mode="multiple" placeholder="Add labels">
                {labelOptions.map((label) => (
                  <Select.Option key={label.id} value={label.id}>
                    {label.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {/* Epic (Conditional) */}
            {['task', 'bug', 'story'].includes(workType) && (
              <Form.Item name="epic_id" label="Epic">
                <Select placeholder="Select epic" allowClear>
                  {epicOptions.map((epic) => (
                    <Select.Option key={epic.id} value={epic.id}>
                      {epic.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            {/* Sprint */}
            <Form.Item name="sprint_id" label="Sprint">
              <Select placeholder="Select sprint">
                {sprintList?.map((sprint) => (
                  <Select.Option
                    key={sprint.sprint_id}
                    value={sprint.sprint_id}
                  >
                    {sprint.sprint_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {/* Dates */}
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="start_date" label="Start date">
                  <DatePicker style={{ width: '100%' }} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item name="due_date" label="Due date">
                  <DatePicker style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>

        <Modal
          title="Add Epic"
          open={isEpicModalVisible}
          onCancel={() => setIsEpicModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsEpicModalVisible(false)}>
              Cancel
            </Button>,

            <Button
              key="submit-continue"
              type="default"
              style={{
                backgroundColor: '#884B9E',
                color: '#fff',
                // borderColor: '#3e0951ff',
              }}
              onClick={() => {
                handleAddEpic();
                setIsEpicModalVisible(false);
                setShowTaskFields(true);
              }}
            >
              Submit
            </Button>,
          ]}
        >
          <Form layout="vertical">
            <Form.Item
              label="Epic Name"
              rules={[{ required: true, message: 'Please enter epic name' }]}
            >
              <Input
                value={epicName}
                onChange={(e) => setEpicName(e.target.value)}
                placeholder="Enter epic name"
              />
            </Form.Item>
          </Form>
        </Modal>
      </Header>
      {showLinkWorkItems && (
        <LinkWorkItems
          isOpen={showLinkWorkItems}
          onClose={handlecloseLinkworkItems}
        />
      )}
    </React.Fragment>
  );
};

export default SubHeaderBar;
